import { TOKEN_STORAGE_KEY } from '../constants'

/**
 * Decodes a JWT token and returns its payload.
 * @param {string} token - JWT token
 * @returns {object|null} Decoded payload or null if invalid
 */
function decodeToken(token) {
  try {
    const payload = token.split('.')[1]
    const decoded = atob(payload)

    return JSON.parse(decoded)
  } catch (e) {
    console.warn('Failed to decode token:', e)
    return null
  }
}

/**
 * Checks if the current user is authenticated and token is still valid.
 * @returns {boolean} User is authenticated and token not expired
 */
export default function isAuthenticated() {
  const token = localStorage.getItem(TOKEN_STORAGE_KEY)
  if (!token) return false

  const payload = decodeToken(token)
  if (!payload || !payload.exp) return false

  const currentTime = Math.floor(Date.now() / 1000)
  return payload.exp > currentTime
}
